import Vue from 'vue';
import VueGtm from '@gtm-support/vue2-gtm';
import {createRouter} from '@/router';
let gtmId = null
const currentUrl = window.location.host
if(currentUrl.indexOf('fr.bestgolfcourse') !== -1) {
  gtmId = 'GTM-KJN6CH2'
} else if(currentUrl.indexOf('vn.bestgolfcourse') !== -1) {
  gtmId = 'GTM-PJJ42WN'
} else if(currentUrl.indexOf('au.bestgolfcourse') !== -1) {
  gtmId = 'GTM-PSDDG7D'
} else if(currentUrl.indexOf('uk.bestgolfcourse') !== -1) {
  gtmId = 'GTM-KQ4V7M9'
} else if(currentUrl.indexOf('bestgolfcourse') !== -1) {
  gtmId = 'GTM-5KTVTPW'
}
if(gtmId) {
  const router = createRouter();

  Vue.use(VueGtm, {
    id: gtmId,
    defer: false, 
    enabled: true, 
    debug: true, 
    loadScript: true, 
    vueRouter: router, 
    ignoredViews: [],
    trackOnNextTick: false
  });
}
export default VueGtm;
